module.exports = __webpack_public_path__ + "static/goodrich-ipad-34bb760480d5f168ad78fd6b08cbf786.jpg";